import axios, { AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '../utils/constant';
import { useMemo } from 'react';
import { SessionInterceptor } from '@reconvert/react-ui-component';
import { Redirect } from '@shopify/app-bridge/actions';

const AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

SessionInterceptor.addInterceptors(AxiosInstance);

const axiosRequest =
  (app: any, shopifyToken: any, token: string) =>
  async (config = {}, isPrivate = true) => {
    let axConfig = { ...config } as AxiosRequestConfig;
    let headers = {};

    if (token && isPrivate) {
      headers = {
        Authorization: `Bearer ${token}`,
        'x-admin': 1,
      };
    } else if (shopifyToken) {
      headers = {
        Authorization: `Bearer ${shopifyToken}`,
      };
    }

    axConfig.headers = { ...(axConfig?.headers || {}), ...headers };
    try {
      const response = await AxiosInstance.request(axConfig);

      checkHeadersForReauthorization(app, response.headers);

      return response;
    } catch (e: any) {
      if (e?.response?.headers) {
        checkHeadersForReauthorization(app, e.response.headers);
      }

      throw e;
    }
  };

const checkHeadersForReauthorization = (app: any, headers: any) => {
  if (headers.get('X-Shopify-API-Request-Failure-Reauthorize') === '1') {
    const authUrlHeader =
      headers.get('X-Shopify-API-Request-Failure-Reauthorize-Url') ||
      `/api/auth`;

    app.dispatch(
      Redirect.toRemote({
        url: decodeURIComponent(
          authUrlHeader.startsWith('/')
            ? `https://${window.location.host}${authUrlHeader}`
            : authUrlHeader
        ),
      })
    );
  }
};

export const useFetch = (app: any, shopifyToken: any, token: string) => {

  const memoizedFetch = useMemo(
    () => axiosRequest(app, shopifyToken, token),
    [app, shopifyToken, token]
  );

  return memoizedFetch;
};

